export interface ErrorTileProps {
  /** Vault path of the file that needs fixing — the single most useful thing to show. */
  path?: string | undefined;
  message: string;
  title?: string;
}

/**
 * The failure state for one widget. Deliberately detailed rather than a generic
 * "something went wrong": these configs are edited by hand and by AI, so the
 * tile has to say which file and which key is wrong to be worth anything.
 */
export function ErrorTile({ path, message, title = 'Config error' }: ErrorTileProps) {
  return (
    <div class="hud-error" role="alert">
      <div class="hud-error__title">{title}</div>
      {path ? <div class="hud-error__path">{path}</div> : null}
      <div class="hud-error__message">{message}</div>
    </div>
  );
}
